import { useNavigate } from 'react-router-dom';

import { useMutation } from '@tanstack/react-query';
import { apis } from 'apis/apis';
import { ILoginData } from 'apis/user_apis';
import { IErrRes } from 'type/db';

import useToast from 'hooks/useToast';
import { getCookie, removeCookie, setCookie } from 'utils/cookies';

// 로그인
export const useLoginMutation = <T>(persistent: boolean, options?: T) => {
	const navigate = useNavigate();
	const toast = useToast();

	return useMutation<any, IErrRes, ILoginData>({
		mutationFn: apis.login,
		onSuccess: (data) => {
			sessionStorage.setItem('wconcept_user_type', 'wconcept_admin');

			if (data.status === 200) {
				setCookie('Authorization', data.data.token);
				navigate(`/dashboard`, {
					replace: true,
				});
			}
		},
		onError: (err) => {
			toast('이메일 또는 비밀번호를 다시 확인하고 시도해주세요.', false, true);
		},
	});
};
